"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { ApiRateMatter } from "@/generated/models/ApiRateMatter";
import { getRandomColorWithSeed } from "@/helpers/Helpers";
import { useRouter } from "next/navigation";
import { useContext, useEffect, useState, type JSX } from "react";
import GroupCardView from "./GroupCardView";
import GroupCardVoteAll from "./vote-all/GroupCardVoteAll";
export enum GroupCardState {
  IDLE = "IDLE",
  REP = "REP",
  NIC = "NIC",
}
export enum CreditDirection {
  ADD = "ADD",
  SUBTRACT = "SUBTRACT",
}
export default function GroupCard(t0) {
  const $ = _c(61);
  const {
    group,
    activeGroupIdVoteAll,
    setActiveGroupIdVoteAll,
    userPlaceholder,
    titlePlaceholder
  } = t0;
  const router = useRouter();
  const {
    connectedProfile
  } = useContext(AuthContext);
  const [state, setState] = useState(GroupCardState.IDLE);
  let t1;
  if ($[0] !== group?.created_by.banner1_color || $[1] !== group?.created_by.handle) {
    t1 = group?.created_by.banner1_color ?? getRandomColorWithSeed(group?.created_by.handle ?? "");
    $[0] = group?.created_by.banner1_color;
    $[1] = group?.created_by.handle;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const banner1 = t1;
  let t2;
  if ($[3] !== group?.created_by.banner2_color || $[4] !== group?.created_by.handle) {
    t2 = group?.created_by.banner2_color ?? getRandomColorWithSeed(group?.created_by.handle ?? "");
    $[3] = group?.created_by.banner2_color;
    $[4] = group?.created_by.handle;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const banner2 = t2;
  let t3;
  if ($[6] !== group || $[7] !== setActiveGroupIdVoteAll) {
    t3 = state_0 => {
      if (!setActiveGroupIdVoteAll || !group) {
        return;
      }
      if (state_0 === GroupCardState.IDLE) {
        setActiveGroupIdVoteAll(null);
      } else {
        setActiveGroupIdVoteAll(group.id);
      }
      setState(state_0);
    };
    $[6] = group;
    $[7] = setActiveGroupIdVoteAll;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const onGroupStateChange = t3;
  let t4;
  if ($[9] !== activeGroupIdVoteAll || $[10] !== group?.id) {
    t4 = () => activeGroupIdVoteAll === group?.id;
    $[9] = activeGroupIdVoteAll;
    $[10] = group?.id;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const getIsActiveGroupVoteAll = t4;
  const isActiveGroupVoteAll = getIsActiveGroupVoteAll();
  let t5;
  if ($[12] !== isActiveGroupVoteAll) {
    t5 = () => {
      if (!isActiveGroupVoteAll) {
        setState(GroupCardState.IDLE);
      }
    };
    $[12] = isActiveGroupVoteAll;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t5);
  let t6;
  if ($[14] !== onGroupStateChange) {
    t6 = () => onGroupStateChange(GroupCardState.IDLE);
    $[14] = onGroupStateChange;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const onActionCancel = t6;
  let t7;
  if ($[16] !== connectedProfile?.handle || $[17] !== onGroupStateChange) {
    t7 = () => {
      if (!connectedProfile?.handle) {
        onGroupStateChange(GroupCardState.IDLE);
      }
    };
    $[16] = connectedProfile?.handle;
    $[17] = onGroupStateChange;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = connectedProfile?.handle;
  let t9;
  if ($[19] !== t8) {
    t9 = [t8];
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  useEffect(t7, t9);
  let t10;
  if ($[21] !== router) {
    t10 = group_0 => {
      router.push(`/network/groups?edit=${group_0.id}`);
    };
    $[21] = router;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const onEditClick = t10;
  const t11 = setActiveGroupIdVoteAll ? onGroupStateChange : undefined;
  const t12 = !!activeGroupIdVoteAll;
  const t13 = setActiveGroupIdVoteAll ? onEditClick : undefined;
  let t14;
  if ($[23] !== group || $[24] !== t11 || $[25] !== t12 || $[26] !== t13 || $[27] !== titlePlaceholder || $[28] !== userPlaceholder) {
    t14 = <GroupCardView group={group} setState={t11} haveActiveGroupVoteAll={t12} onEditClick={t13} userPlaceholder={userPlaceholder} titlePlaceholder={titlePlaceholder} />;
    $[23] = group;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
    $[27] = titlePlaceholder;
    $[28] = userPlaceholder;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== group || $[31] !== onActionCancel) {
    t15 = <GroupCardVoteAll group={group} onCancel={onActionCancel} matter={ApiRateMatter.Rep} />;
    $[30] = group;
    $[31] = onActionCancel;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== group || $[34] !== onActionCancel) {
    t16 = <GroupCardVoteAll group={group} onCancel={onActionCancel} matter={ApiRateMatter.Cic} />;
    $[33] = group;
    $[34] = onActionCancel;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t14 || $[37] !== t15 || $[38] !== t16) {
    t17 = {
      [GroupCardState.IDLE]: t14,
      [GroupCardState.REP]: t15,
      [GroupCardState.NIC]: t16
    };
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  const components = t17;
  const isIdle = state === GroupCardState.IDLE;
  const cardLabel = group?.name ?? titlePlaceholder ?? "View community group details";
  const cardHref = group ? `/network?page=1&group=${group.id}` : undefined;
  const t18 = `linear-gradient(135deg, ${banner1} 0%, ${banner2} 100%)`;
  let t19;
  if ($[40] !== t18) {
    t19 = {
      background: t18
    };
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const gradientStyle = t19;
  let t20;
  if ($[42] !== cardHref || $[43] !== cardLabel || $[44] !== isIdle || $[45] !== router) {
    t20 = isIdle && cardHref && <button type="button" onClick={() => router.push(cardHref)} className="tw-absolute tw-inset-0 tw-z-0 tw-rounded-xl tw-border-0 tw-bg-transparent tw-p-0 tw-cursor-pointer focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-500" aria-label={`Open ${cardLabel}`} />;
    $[42] = cardHref;
    $[43] = cardLabel;
    $[44] = isIdle;
    $[45] = router;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  const t21 = `tw-relative tw-overflow-hidden tw-group tw-rounded-xl tw-border tw-border-solid tw-border-white/5 tw-bg-iron-950 tw-backdrop-blur-sm tw-shadow-sm tw-shadow-black/20 tw-transition-all tw-duration-300 tw-ease-out tw-cursor-pointer desktop-hover:hover:tw-shadow-lg desktop-hover:hover:tw-shadow-black/40 desktop-hover:hover:tw-translate-y-[-1px] focus-visible:tw-ring-2 focus-visible:tw-ring-primary-500 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-iron-900 focus-visible:tw-outline-none tw-no-underline ${isIdle ? "tw-group desktop-hover:hover:tw-shadow-lg desktop-hover:hover:tw-shadow-black/40 desktop-hover:hover:tw-translate-y-[-1px]" : ""}`;
  let t22;
  if ($[47] !== gradientStyle) {
    t22 = <div className="tw-absolute tw-inset-0 tw-opacity-80 tw-transition-opacity tw-duration-300 tw-ease-out desktop-hover:group-hover:tw-opacity-95" style={gradientStyle} />;
    $[47] = gradientStyle;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-b from-black/25 via-black/10 to-transparent" />;
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== t22) {
    t24 = <div className="tw-absolute tw-inset-0 tw-rounded-t-xl tw-h-1">{t22}{t23}</div>;
    $[50] = t22;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  const t25 = components[state];
  let t26;
  if ($[52] !== t25) {
    t26 = <div className="tw-flex tw-flex-1 tw-flex-col tw-rounded-b-xl tw-bg-iron-950">{t25}</div>;
    $[52] = t25;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t21 || $[55] !== t24 || $[56] !== t26) {
    t27 = <div className={t21}>{t24}{t26}</div>;
    $[54] = t21;
    $[55] = t24;
    $[56] = t26;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] !== t20 || $[59] !== t27) {
    t28 = <div className="tw-col-span-1 tw-relative">{t20}{t27}</div>;
    $[58] = t20;
    $[59] = t27;
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  return t28;
}